<ng-container *ngIf="type === tableButtonsEnum.STROKED; else raised">
  <ng-template [permission]="item.hashButton"
               *ngFor="let item of buttons">
    <button color="primary"
            mat-stroked-button
            class="table-custom__button"
            matTooltipPosition="above"
            ngClass.xs="w-100"
            ngClass.gt-xs="mr-1"
            [ngClass]="item.styleButton ? item.styleButton(itemDataSource) : ''"
            [matTooltip]="item.tooltip ? item.tooltip : ''"
            [disabled]="item.disabled ? item.disabled(itemDataSource) : false"
            (click)="item.onClick(itemDataSource, $event)">
      <span *ngIf="item.icon">
        <mat-icon>{{item.icon}}</mat-icon>
      </span>
      <span *ngIf="item.label">
        {{item.label}}
      </span>
    </button>
  </ng-template>
</ng-container>

<ng-template #raised>
  <ng-container *ngIf="type === tableButtonsEnum.RAISED; else icons">
    <ng-template [permission]="item.hashButton"
                 *ngFor="let item of buttons">
      <button class="table-custom__button"
              color="primary"
              mat-raised-button
              matTooltipPosition="above"
              ngClass.xs="w-100"
              ngClass.gt-xs="mr-1"
              [ngStyle]="item.styleButton(itemDataSource)"
              [disabled]="item.disabled ? item.disabled(itemDataSource) : false"
              [matTooltip]="item.tooltip ? item.tooltip : ''"
              (click)="item.onClick(itemDataSource, $event)">
        <span *ngIf="item.icon">
          <mat-icon>{{item.icon}}</mat-icon>
        </span>
        <span *ngIf="item.label">
          {{item.label}}
        </span>
      </button>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #icons>
  <ng-container *ngIf="type === tableButtonsEnum.ICON">
    <ng-template [permission]="item.hashButton"
                 *ngFor="let item of buttons">
      <button class="table-custom__button"
              color="primary"
              mat-icon-button
              matTooltipPosition="above"
              ngClass.gt-xs="mr-1"
              ngClass.xs="w-100"
              [ngStyle]="item?.styleButton ? item?.styleButton(itemDataSource) : ''"
              [matTooltip]="item.tooltip ? item.tooltip : ''"
              [disabled]="item.disabled ? item.disabled(itemDataSource) : false"
              (click)="item.onClick(itemDataSource, $event)">
        <mat-icon>{{item.icon}}</mat-icon>
      </button>
    </ng-template>
  </ng-container>
</ng-template>
